{
  "name": "@metasession.co/devaudit-cli",
  "version": "0.3.6",
  "description": "DevAudit CLI — installs, syncs, and operates the Metasession SDLC across consumer projects.",
  "type": "module",
  "bin": {
    "devaudit": "./bin/devaudit.js"
  },
  "main": "./dist/index.js",
  "exports": {
    ".": "./dist/index.js"
  },
  "files": [
    "bin",
    "dist",
    "sdlc",
    "scripts",
    "README.md",
    "LICENSE"
  ],
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "bundle:templates": "node tools/bundle-templates.mjs",
    "prepack": "npm run build && npm run bundle:templates",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "start": "node ./bin/devaudit.js"
  },
  "dependencies": {
    "@clack/prompts": "^0.8.2",
    "@metasession.co/devaudit-plugin-sdk": "^0.3.6",
    "ajv": "^8.20.0",
    "commander": "^12.1.0",
    "consola": "^3.2.3",
    "env-paths": "^3.0.0",
    "execa": "^9.5.1"
  },
  "devDependencies": {
    "@types/js-yaml": "^4.0.9",
    "@types/node": "^22.9.0",
    "js-yaml": "^5.1.0",
    "msw": "^2.7.0",
    "tsup": "^8.3.5",
    "typescript": "^5.7.2",
    "vitest": "^4.1.6"
  },
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/metasession-dev/DevAudit-Installer",
    "directory": "cli"
  },
  "license": "Apache-2.0"
}
